module.exports = __webpack_public_path__ + "img/bell.49e1e4f1.svg";